import { Group, Input, NumberFormatter, NumberInput } from '@mantine/core'
import React from 'react'

interface CustomProps
  extends React.ComponentPropsWithoutRef<typeof NumberFormatter> {
  label?: string
  value: string | number
  suffix?: string
}

const AppNumberFormatter = ({
  label,
  value,
  fw,
  suffix,
  ...otherProps
}: CustomProps) => {
  // return (
  //   <NumberInput
  //     {...otherProps}
  //     disabled
  //     w="100%"
  //     label={label}
  //     value={value}
  //     hideControls
  //   />
  // )

  return (
    <Group gap={4} justify="flex-end" wrap="nowrap">
      <NumberFormatter
        {...otherProps}
        style={{ fontFamily: 'inherit', fontWeight: 'inherit' }}
        value={value}
        // decimalSeparator=','
        // thousandSeparator='.'
        // decimalScale={2}
        // fixedDecimalScale={true}
      />
      {value && suffix && <Group opacity={0.4}>{suffix}</Group>}
    </Group>
  )
}

export default AppNumberFormatter
